// アコーディオン (c-basics-accordion)
// [data-basics-accordion] 直下の [data-basics-accordion-trigger] クリックで開閉
const main = () => {
    const items = document.querySelectorAll('[data-basics-accordion]');
    if (items.length === 0) return;

    items.forEach((item) => {
        const trigger = item.querySelector('[data-basics-accordion-trigger]');
        const body = item.querySelector('[data-basics-accordion-body]');
        if (!trigger) return;

        trigger.addEventListener('click', () => {
            const isOpen = item.toggleAttribute('data-active');
            trigger.setAttribute('aria-expanded', String(isOpen));
            if (body) body.setAttribute('aria-hidden', String(!isOpen));
        });
    });
};

export default main;
